<template>
  <div>
    <header-sales></header-sales>

    <div class="fv ct" style="width: 100vw; height: 90vh;">
        <div class="fv cc" style="width: 100%; height: 37%; background: linear-gradient(#005a9f, #1899d6)">
            <img src="/dist/logo-header.png" style="height: 150px;">
        </div>
        <div class="fv lc" v-show="!showItemsPromo" style="width: 700px; height:50px"> </div>  
        <div class="fv lc" style="width: 700px; margin-top:15px;">
            <div class="fh cc" style="font-size: 10px; color: #5c666f; margin-left: 243px">
                Seleccione Moneda: 
            </div>  
            <select style="width: 212px; height: 30px; padding-left: 5px; margin-left: 232px; border-radius: 5px; 
                           border-style: solid; border: none; border-width: 1px; border: 1px solid #dddddd" 
                           v-model="idMoneda" v-show="showMoneda">
                <option v-for="option in moneda" v-bind:value="option.id" >{{ option.nombre }}</option>
            </select>
        </div>
        <div class="fv ct" style="width: 710px; height: 65%; margin-top:15px; overflow: auto">
            <div class="fh lc" style="width: 700px;">
                <div class="oblea-NuevoPedido" @click="btnNuevoPedido">
                    <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-add.png" >
                    <p id="label-realizarPedido">{{laberPedido}}</p>
                </div>
                <div class="oblea-NuevoPedido" @click="btnEstadoPedido">
                    <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-pedidos.png" >
                    <p id="label-realizarPedido">Estado de Pedidos</p>
                </div>
                <div class="oblea-NuevoPedido" @click="btnCuentaCorriente">
                    <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-cc.png" >
                    <p id="label-realizarPedido">Cuenta Corriente</p>
                </div>
            </div>
            <div class="fh lc" v-show="showItemsPromo" style="width: 700px; margin-top:20px;">
                <div class="fh lc" v-show="showItemsPromo" style="margin-left:12px; font-size: 15px; color: #5c666f; font-weight:500">
                    Promociones
                </div>
                <div id="verTodas" class="fh lb" @click="verPromociones"  v-show="showItemsPromo" style="font-size: 12px; 
                    color: #4969B2; font-weight:600; margin-left: 8px">
                    Ver Todas
                </div>
            </div>
            <div class="fh lc" v-show="showItemsPromo" style="width: 700px; height:130px; margin-top:5px;">
                <item-promocion v-for="item in itemsPromo " :item='item'></item-promocion>
            </div>
        </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import HeaderSales from "@components/views/header.vue";
import ItemPedidoHome from "@components/views/home/itemPedidoHome.vue";
import ItemPromocion from "@components/views/home/itemPromocionHome.vue";
import moment from 'moment' 

export default {

  name: "Home",

  components: {
    "header-sales": HeaderSales,
    "item-pedido-home": ItemPedidoHome,
    "item-promocion": ItemPromocion,
  },


 data() {
    return {
      showMoneda:true,  
      moneda:[
        {
          id:1,
          nombre: 'Pesos'
        }, 
        {
          id:2,
          nombre: 'Dolares'
        } 
      ],
      idMoneda: this.$store.state.pedido.idMoneda  
    };
  },

  watch: {
    idMoneda(val) 
    {
      this.$store.commit('pedido/saveMoneda',val)
    }
  },

  computed: {
    itemsPromo () {
        return this.$store.getters['pedido/getPromoHome']
    },
    showItemsPromo () {
        if (this.$store.state.pedido.promociones.length > 0) {
          return true
        }
        else {
          return false 
        }
    },
    laberPedido() {
       if (this.$store.state.pedido.carrito.length > 0) {
         return "Continuar Pedido"
       } 
       else {
         return "Nuevo Pedido"
       }
    }
  },



  methods: {
    getPromociones() {
      this.$store.commit('loader/start')
      var idCliente = ''
      if (this.$store.state.user.usuario.EsEmpleado) {
        idCliente = this.$store.state.user.cliente.Id
      }
      else {
        idCliente = this.$store.state.user.usuario.EsEmpleado
      }
      axios.get('/WebSalesPromociones?ClienteId='+idCliente,{
         headers:{        
            Token:        this.$store.state.user.usuario.Token,
            ClientSecret: process.env.CLIENT_SECRET
            }})
         .then((response) => {
            this.$store.commit("loader/stop"); 
            if (response.data.Code == 0) {
              var promos = response.data.Promociones
              var promosVigentes = []
              if (promos != null) {
                promos.forEach((j) => { 
                    var FechaInicio =  j.FechaInicio
                    var FechaFin =  j.FechaFin
                    moment.defaultFormat = "YYYY-MM-DD HH:mm:ss";
                    var fechaIniMillis = moment(FechaInicio, moment.defaultFormat).toDate().getTime()
                    var fechaFinMillis = moment(FechaFin, moment.defaultFormat).toDate().getTime() + 86399000
                    var fechaActualMillis = Date.now()
                    if ((fechaActualMillis >= fechaIniMillis) && (fechaActualMillis <= fechaFinMillis)) {
                      promosVigentes.push(j)
                    }
                });    
              }
              this.$store.commit('pedido/savePromociones',promosVigentes)
            }
          },
          (error) => { 
            this.$store.commit("loader/stop");
          }
      )
    },

    btnNuevoPedido() 
    {
      if (this.$store.state.user.cliente != null)
      {
        if (this.$store.state.pedido.deposito == null)
        {
          this.$store.commit("pedido/saveGoTo",'producto');
          this.$router.push({ name: "depositos" })
        }
        else
        {
          this.$router.push({ name: 'realizarPedidoCat' });
        }
      }
      else
      {
        this.$router.push({ name: "clientes" })
      }
    },

    btnEstadoPedido() 
    {
      if (this.$store.state.user.cliente != null)
      {
        this.$router.push({ name: "estadoPedido" });
      }
      else
      {
        this.$router.push({ name: "clientes" })
      }
    },

    btnCuentaCorriente() 
    {
      if (this.$store.state.user.cliente != null)
      {
        this.$router.push({ name: "ctacte" });
      }
      else
      {
        this.$router.push({ name: "clientes" })
      }
    },

    verPromociones () {
      if (this.$store.state.user.cliente != null) {
        if (this.$store.state.pedido.deposito == null) {
          this.$store.commit("pedido/saveGoTo",'promo');
          this.$router.push({ name: "depositos" })
        }
        else {
          this.$router.push({ name: 'promociones' });
        }
      }
      else {
        this.$router.push({ name: "clientes" })
      }
    },

  },


  mounted() 
  {
    localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
    this.$store.commit("loader/stop");
    if(this.$store.state.user.cliente) {
      this.getPromociones()
    }
    if(this.$store.state.user.usuario.EsEmpleado) {
      this.showMoneda=true  
      this.idMoneda =  this.$store.state.pedido.idMoneda
    }
    else {
      this.showMoneda=false  
    }
  }

};

</script>




<style scoped>

.verTodos:hover {
  cursor: pointer;
}

.oblea-NuevoPedido {
  width: 210px;
  height: 130px;
  border-width: 1px;
  border: 1px solid #dddddd;
  background: #f0f0f0;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 2px 2px 4px #dddddd;  
  -webkit-box-shadow: 2px 2px 4px #dddddd;  
  -moz-box-shadow:    2px 2px 4px #dddddd;  
  border-radius: 10px;
}


.oblea-NuevoPedido:hover {
  cursor: pointer;
  background: #F7FCFF;
}


#label-realizarPedido {
  margin-top: 8px;
  font-size: 12px;
  color: #4969B2;
}




#verTodas:hover{
    cursor: pointer;
  }


/* width */
  ::-webkit-scrollbar {
      width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd; 
      border-radius: 10px;
  }
  
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb; 
      border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc; 
  }
  
  
  ::-webkit-scrollbar { 
  display: block; }
 


</style>



// WEBPACK FOOTER //
// src/components/views/home/home.vue